module.exports = __webpack_public_path__ + "static/media/logo.818e3f3f.webp";